module.exports = __webpack_public_path__ + "img/our-vision-bg.ca97cd0a.png";